import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/nenkintuuti_01.png")